import BetaTitle from '@/creditflowresearch/ui/common/components/Title/BetaTitle';

import styles from '@/creditflowresearch/ui/components/TopCompanies/styles.module.scss';

const TopCompaniesTitle = ({ isCorporate, title }: { isCorporate: boolean, title: string }) => (
  <BetaTitle
    title={ title }
    showBeta={ isCorporate }
    TextWrapper={ ({ className, children }) => <h3 className={ className }>{ children }</h3> }
    className={ styles.title }
  />
);

export default TopCompaniesTitle;
